import { get } from './get';

const organizationAdapter = {
  get
};

export { organizationAdapter };
